import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';

import { REQUEST_ATTEMPT_TIMEOUT_MS } from '@app/core/http/request-timeout.context';

/**
 * UNA sola responsabilidad: si la petición trae `REQUEST_ATTEMPT_TIMEOUT_MS`, le
 * pone ese tope de tiempo a ESTE intento (`TimeoutError` al vencer, y la petición
 * se cancela). Sin marca, o con un valor no finito o ≤ 0, la deja intacta.
 *
 * Se registra el ÚLTIMO en `app.config.ts` (el más cercano al backend): así el tope
 * mide solo la espera del servidor, intento por intento, y nunca el tiempo que el
 * diálogo de sesión de `auth.interceptor.ts` espera la decisión del operador.
 * Vive aparte del monolito a propósito (CLAUDE.md: un interceptor por concern).
 */
@Injectable()
export class RequestTimeoutInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const ms = request.context.get(REQUEST_ATTEMPT_TIMEOUT_MS);
    if (typeof ms !== 'number' || !Number.isFinite(ms) || ms <= 0) return next.handle(request);
    return next.handle(request).pipe(timeout(ms));
  }
}
